import createIcon from '../../createIcon';

/**
 * @component @name LabelOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4yNSAyLjg3NUwyMC4yNSAxOS44NzVMMTkgMjEuMTI1TDE3IDE5LjEyNUg1QzMuOSAxOS4xMjUgMyAxOC4yMjUgMyAxNy4xMjVWNy4xMjVDMyA2LjU3NSAzLjIzIDYuMDc1IDMuNTkgNS43MTVMMiA0LjEyNUwzLjI1IDIuODc1Wk0yMiAxMi4xMjVMMTcuNjMgNS45NjVDMTcuMjcgNS40NTUgMTYuNjcgNS4xMjUgMTYgNS4xMjVIOEwxOSAxNi4xMjVMMjIgMTIuMTI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LabelOff = createIcon('LabelOff', [
  [
    'path',
    {
      d: 'M3.25 2.875L20.25 19.875L19 21.125L17 19.125H5C3.9 19.125 3 18.225 3 17.125V7.125C3 6.575 3.23 6.075 3.59 5.715L2 4.125L3.25 2.875ZM22 12.125L17.63 5.965C17.27 5.455 16.67 5.125 16 5.125H8L19 16.125L22 12.125Z',
      key: 'qn56g2',
    },
  ],
]);

export default LabelOff;
